<!-- container-xxl -->
<div class="content-wrapper p-0">
	<app-content-header [contentHeader]="contentHeader"></app-content-header>
	<div class="content-body">
		<section class="app-ecommerce-details">
			<!-- <div class="card"> -->
				<!-- <div class="card-body"> -->
					<!-- <div class="stepper-wrapper">
						<div class="stepper-item" [ngClass]="{ 'completed': stage.status }"
							*ngFor="let stage of stageData">
							<div class="step-counter">{{stage.id}}</div>
							<div class="step-name">{{stage.paraDescription}}</div>
						</div>
					</div> -->
					<div class="row">
						<div class="col-8">
							<fieldset class="border" style="padding: 0.7rem;">
								<legend class="w-auto">
									<h5 style="margin-top: 7px;">Project Details</h5>
								</legend>
								<div class="row">
									<div class="col-5 text-wrap">
										<h3><b>{{form1_data?.piName}}</b></h3>
										<!-- <span>{{form1_data?.subjectArea}}</span> -->
									</div>
									<!-- <div class="col-4">
										<div class="form-group row">
											<div class="col-5 col-form-label">
												<label><b>Email ID:</b></label>
											</div>
											<div class="col-7 col-form-label">
												<p class="text-justify">{{form1_data?.emailID}}</p>
											</div>
										</div>
										<div class="form-group row">
											<div class="col-5 col-form-label">
												<label><b>Mobile No.:</b></label>
											</div>
											<div class="col-7 col-form-label">
												<p class="text-justify">{{form1_data?.mobileNo}}</p>
											</div>
										</div>
									</div> -->
									<div class="col-3">
										<div class="form-group row">
											<div class="col-5 col-form-label">
												<label><b>Created Date:</b></label>
											</div>
											<div class="col-7 col-form-label">
												<p class="text-justify">{{form1_data?.createdAt}}</p>
											</div>
										</div>
										<div class="form-group row">
											<div class="col-5 col-form-label">
												<label><b>Modified Date:</b></label>
											</div>
											<div class="col-7 col-form-label">
												<p class="text-justify">{{form1_data?.modifiedAt}}</p>
											</div>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="col-6">
										<div class="form-group row">
											<div class="col-4 col-form-label">
												<label><b>Application No.:</b></label>
											</div>
											<div class="col-8 col-form-label">
												<p class="text-justify">{{form1_data?.applicationNumber}}</p><br />
											</div>
										</div>
									</div>
									<div class="col-6">
										<div class="form-group row">
											<div class="col-4 col-form-label">
												<label><b>Applicant Category:</b></label>
											</div>
											<div class="col-8 col-form-label">
											
										<p class="text-justify" *ngIf="form1_data?.applicantCategory == '1'" > Academic Institutions</p>
							            <p class="text-justify" *ngIf="form1_data?.applicantCategory == '2'" > R&D Institutions</p>
							            <p class="text-justify" *ngIf="form1_data?.applicantCategory == '3'" > Government Institutions</p>
							            <p class="text-justify" *ngIf="form1_data?.applicantCategory == '4'" > PSUs</p>
							            <p class="text-justify" *ngIf="form1_data?.applicantCategory == '5'" > Private Research Institutions</p>
							           <p class="text-justify" *ngIf="form1_data?.applicantCategory == '6'" > Industries in partnership with above mentioned entities</p>
							           <p class="text-justify" *ngIf="form1_data?.applicantCategory == '7'" > Consortium/ JV (mention lead partner with composition)</p>
											</div>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="col-6">
										<div class="form-group row">
											<div class="col-4 col-form-label">
												<label><b>COEs Title:</b></label>
											</div>
											<div class="col-8 col-form-label text-justify">
												<p class="text-justify">{{form1_data?.coeTitle}}</p>
											</div>
										</div>
									</div>
									<div class="col-6">
										<div class="form-group row">
											<div class="col-4 col-form-label">
												<label><b>Total Project Cost with MNRE share requested (In Rs.):</b></label>
											</div>
											<div class="col-8 col-form-label text-justify">
												<p class="text-justify">{{form1_data?.totalCostMnreShare}}</p>
											</div>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="col-6">
										<div class="form-group row">
											<div class="col-4 col-form-label pr-0">
												<label><b>Status of Work being done in other National/International Institutions/ Industries:</b></label>
											</div>
											<div class="col-8 col-form-label pr-0">
												<p class="text-justify">{{form1_data?.statusOfWork}}</p>
											</div>
										</div>
									</div>
									<!-- <div class="col-6">
										<div class="form-group row">
											<div class="col-4 col-form-label pr-0">
												<label><b>Share of implementing /participating Institutions in the total
														cost
														(Rs.):</b></label>
											</div>
											<div class="col-8 col-form-label">
												<p class="text-justify">{{form1_data?.shareImplementing}}</p>
											</div>
										</div>
									</div> -->
								</div>
							
								<!-- <div class="row">
									<div class="col-6">
										<div class="form-group row">
											<div class="col-4 col-form-label">
												<label><b>Category of Implementing Institution(s):</b></label>
											</div>
											<div class="col-8 col-form-label">
												<p class="text-justify">{{form1_data?.category_imp_institution}}</p>
											</div>
										</div>
									</div>
									<div class="col-6">
										<div class="form-group row">
											<div class="col-4 col-form-label">
												<label><b>Darpan Portal RegistrationID:</b></label>
											</div>
											<div class="col-8 col-form-label">
												<p class="text-justify">{{form1_data?.darpanPortlRegisterID}}</p>
											</div>
										</div>
									</div>
								</div> -->
							
								<div class="row">
									<div class="col-12">
										<div class="form-group row">
											<div class="col-2 col-form-label">
												<label><b>Break-up of sources of balance cost:</b></label>
											</div>
											<div class="col-10 col-form-label text-justify">
												<p class="text-justify">{{form1_data?.sourceBalanceCost}}</p>
											</div>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="col-12">
										<div class="form-group row">
											<div class="col-2 col-form-label">
												<label><b>Pilot Technology Development details:</b></label>
											</div>
											<div class="col-10 col-form-label text-justify">
												<p class="text-justify">{{form1_data?.pilotTechnologyDetail}}</p>
											</div>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="col-12">
										<div class="form-group row">
											<div class="col-2 col-form-label">
												<label><b>Objectives:</b></label>
											</div>
											<div class="col-10 col-form-label text-justify">
												<p class="text-justify">{{form1_data?.objectives}}</p>
											</div>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="col-12">
										<div class="form-group row">
											<div class="col-2 col-form-label">
												<label><b>Summary:</b></label>
											</div>
											<div class="col-10 col-form-label text-justify">
												<p class="text-justify">{{form1_data?.summary}}</p>
											</div>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="col-12">
										<div class="form-group row">
											<div class="col-2 col-form-label">
												<label><b>Timelines:</b></label>
											</div>
											<div class="col-10 col-form-label text-justify">
												<p class="text-justify">{{form1_data?.timelines}}</p>
											</div>
										</div>
									</div>
								</div>	
								<div class="row">
									<div class="col-12">
										<div class="form-group row">
											<div class="col-2 col-form-label">
												<label><b>Details of functioning of CoE:</b></label>
											</div>
											<div class="col-10 col-form-label text-justify">
												<p class="text-justify">{{form1_data?.detailFunctioning}}</p>
											</div>
										</div>
									</div>
								</div>	
							</fieldset>
						</div>
						<div class="col-4">
							<fieldset class="border" style="padding: 0.7rem;">
								<legend class="w-auto">
									<h5 style="margin-top: 7px;">Principal Investigator(s)</h5>
								</legend>
								<div class=" table-responsive">
								<table class="table table-striped table-bordered">
								
									<tbody>
										<tr >
											<td> Name</td>
											<td> {{form1_data?.piName}}</td>
										</tr>
										<tr >
											<td>Contact No.</td>
											<td> {{form1_data?.piTelephone}}</td>
										</tr>
										<tr >
											<td> Email Id</td>
											<td> {{form1_data?.piEmail}}</td>
										</tr>
										<tr >
											<td> Fax</td>
											<td> {{form1_data?.piFax}}</td>
										</tr>

										<tr >
											<td> Download CV</td>
											<td>
												<span *ngIf="(form1_data?.pICvFileName.value != '')" class="text-primary" >
													<a href="{{form1_data?.pICvFileName}}"
														target="_blank">
													<i class="feather avatar-icon font-medium-1 icon-arrow-down-circle"
															title="Download Document"></i>
												</a> 
												</span>
												
											</td>
										</tr>
										
									</tbody>
								</table>
								</div>
								
							</fieldset>
							<br />

							<fieldset class="border" style="padding: 0.7rem;">
								<legend class="w-auto">
									<h5 style="margin-top: 7px;">Co-Principal Investigator(s)</h5>
								</legend>
								<div class=" table-responsive">
								<table class="table table-striped table-bordered">
								
									<tbody>
										<tr >
											<td> Name</td>
											<td> {{form1_data?.coPiName}}</td>
										</tr>
										<tr >
											<td>Contact No.</td>
											<td> {{form1_data?.coPiTelephone}}</td>
										</tr>
										<tr >
											<td> Email Id</td>
											<td> {{form1_data?.coPiEmail}}</td>
										</tr>
										<tr >
											<td> Fax</td>
											<td> {{form1_data?.coPiFax}}</td>
										</tr>
										<tr>
										<td > Download CV</td>
										<td>
											<!-- <span *ngIf="(form1_data?.coPICvFileName.value != '')" class="text-primary" >
												<a href="{{form1_data?.coPICvFileName}}"
													target="_blank">
												<i class="feather avatar-icon font-medium-1 icon-arrow-down-circle"
														title="Download Document"></i>
											</a> 
											</span> -->
											<span  class="text-primary" >
												<a href="{{form1_data?.coPICvFileName}}"
													target="_blank">
												<i class="feather avatar-icon font-medium-1 icon-arrow-down-circle"
														title="Download Document"></i>
											</a> 
											</span>
											
										</td>
									  </tr>
										
									</tbody>
								</table>
								</div>
								
							</fieldset>
							<br />

							<fieldset class="border" style="padding: 0.7rem;">
								<legend class="w-auto">
									<h5 style="margin-top: 7px;">Additional Co-Principal Investigator</h5>
								</legend>
								<div class=" table-responsive">
								<table class="table table-striped table-bordered">
								
									<tbody>
										<tr >
											
											<td> {{form1_data?.additionalCoPiDetail}}</td>
										</tr>
										
										
									</tbody>
								</table>
								</div>
								
							</fieldset>
<br>
							<fieldset class="border" style="padding: 0.7rem;">
								<legend class="w-auto">
									<h5 style="margin-top: 7px;">Substantiated with letters/agreements</h5>
								</legend>
								<div class=" table-responsive">
								<table class="table table-striped table-bordered">
								
									<tbody>
										<tr>
										<td > Download</td>
										<td>
											
											<span *ngIf="(form1_data?.subLettersFileName.value != '')"  class="text-primary" >
												<a href="{{form1_data?.subLettersFileName}}"
													target="_blank">
												<i class="feather avatar-icon font-medium-1 icon-arrow-down-circle"
														title="Download Document"></i>
											</a> 
											</span>
											
										</td>
									  </tr>
										
									</tbody>
								</table>
								</div>
								
							</fieldset>
							<br />


							
						</div>
					</div>

					<div class="row">
						<div class="form-group col-12">
							<!-- <h4>Proposal Format - 2</h4> -->
							<fieldset class="border" style="padding: 0.7rem;">
								<legend class="w-auto">
									<h5 style="margin-top: 7px;">Proposed cost</h5>
								</legend>
								<div class="table-responsive table-bordered">
									<table class="table mb-0">
										<thead>
											<tr>
												<th scope="col" class="text-wrap" rowspan="2">Proposed cost: (Details of
													equipment along
													with justification to be provided separately in the Format as per
													Annexure
													I)</th>
												<th scope="col" class="text-wrap" rowspan="2">SR. No.</th>
												<th scope="col" class="text-wrap" rowspan="2">Item</th>
												<th scope="col" class="text-wrap"  rowspan="2">
													Total Cost
												</th>
												<th scope="col" class="text-wrap" style="text-align: center;"
												[attr.colspan]="noOfYeararray.length">
													Amount (Rs.)
												</th>
											</tr>
											<tr>
												<th scope="col" class="text-wrap"  *ngFor="let y of noOfYeararray">
													{{y.key}}
												</th>
											</tr>
										</thead>
										<tbody>
											<tr *ngFor="let item of proposedCostArray; let $index=index">
												<td *ngIf="$index==0" [attr.rowspan]="proposedCostArray.length"></td>
												<td scope="col" class="text-wrap">{{$index + 1}}.</td>
												<td scope="col" class="text-wrap">
													<span>{{item?.proposedCostItemName}}</span>
												</td>
												<td scope="col" class="text-wrap">
													<span>{{item?.totalCost}}</span>
												</td>
												<td scope="col" class="text-wrap" *ngFor="let y of item?.years; let $index1 = index1">
													<span>{{y.value}}</span>
												</td>
											</tr>
											<tr>
												<td style="border-top: none;"></td>
												<td scope="col" class="text-wrap">Total</td>
												<td scope="col" class="text-wrap"></td>
												<td scope="col" class="text-wrap">
													<span>{{total}}</span>
												</td>
												<td scope="col" class="text-wrap" *ngFor="let y of noOfYeararray">
													<span>{{y.proposedCostTotal}}</span>
												</td>
											</tr>
										</tbody>
									</table>
									<table class="table">
										<tbody>
											
											
											
											<tr>
												<td scope="col" class="text-wrap" colspan="3"><b>Other Information</b>
												</td>
											</tr>
											<tr>
												<td scope="col" class="text-wrap text-justify">Annexure-I</td>
												<td class="text-justify">
													<span></span>
												</td>
												<td *ngIf="(form2_other_data?.annexureFirstFile != '')">
													<a href="{{form2_other_data?.annexureFirstFile}}"
														target="_blank"><i
															class="feather avatar-icon font-medium-1 icon-arrow-down-circle"
															title="Download Document"></i></a>
												</td>
											</tr>
											<tr>
												<td scope="col" class="text-wrap text-justify">
													ANNEXURE-II(A)
												</td>
												<td class="text-justify">
													<span></span>
												</td>
												<td *ngIf="(form2_other_data?.annexureSecondAFile != '')">
													<a href="{{form2_other_data?.annexureSecondAFile}}"
														target="_blank"><i
															class="feather avatar-icon font-medium-1 icon-arrow-down-circle"
															title="Download Document"></i></a>

												</td>
											</tr>
											<tr>
												<td scope="col" class="text-wrap text-justify">
													ANNEXURE-II(B)
												</td>
												<td class="text-justify">
													<span></span>
												</td>
												<td *ngIf="(form2_other_data?.annexureSecondBFile != '')">
													<a href="{{form2_other_data?.annexureSecondBFile}}"
														target="_blank"><i
															class="feather avatar-icon font-medium-1 icon-arrow-down-circle"
															title="Download Document"></i></a>
												</td>
											</tr>
											<tr>
												<td scope="col" class="text-wrap text-justify">
													<span>ANNEXURE-II (C)</span>
												</td>
												<td>
												</td>
												<td *ngIf="(form2_other_data?.annexureSecondCFile != '')">
													<a href="{{form2_other_data?.annexureSecondCFile}}"
														target="_blank"><i
															class="feather avatar-icon font-medium-1 icon-arrow-down-circle"
															title="Download Document"></i></a>
												</td>
											</tr>
											<tr>
												<td scope="col" class="text-wrap text-justify">
													<span>ANNEXURE-II (D)</span>
												</td>
												<td>
												</td>
												<td *ngIf="(form2_other_data?.annexureSecondDFile != '')">
													<a href="{{form2_other_data?.annexureSecondDFile}}"
														target="_blank"><i
															class="feather avatar-icon font-medium-1 icon-arrow-down-circle"
															title="Download Document"></i></a>
												</td>
											</tr>
											<tr>
												<td scope="col" class="text-wrap text-justify">
													<span>ANNEXURE-II (E)</span>
												</td>
												<td>
												</td>
												<td *ngIf="(form2_other_data?.annexureSecondEFile != '')">
													<a href="{{form2_other_data?.annexureSecondEFile}}"
														target="_blank"><i
															class="feather avatar-icon font-medium-1 icon-arrow-down-circle"
															title="Download Document"></i></a>
												</td>
											</tr>

										
										</tbody>
									</table>
								</div>
							</fieldset>
						</div>
					</div>
					<!-- <div class="row">
						<div class="form-group col-12">
							<fieldset class="border" style="padding: 0.7rem;">
								<legend class="w-auto">
									<h5 style="margin-top: 7px;">Cost of Equipment</h5>
								</legend>
								<div class="table-responsive table-bordered">
									<table class="table table-striped table-bordered">
										<thead>
											<tr>
												<th scope="col" class="text-wrap">Sr. No.</th>
												<th scope="col" class="text-wrap">Name of the Equipment along with make
													&
													model</th>
												<th scope="col" class="text-wrap">Imported/ Indigenous</th>
												<th scope="col" class="text-wrap">Estimated Costs (in INR Currency
													also
													for imported
													equipment)*</th>
												<th scope="col" class="text-wrap">Justification</th>
												<th scope="col" class="text-wrap"></th>
											</tr>
										</thead>
										<tbody>
											<tr *ngFor="let item of form3coeArray; let $index=index">
												<td scope="col" class="text-wrap">{{$index + 1}}.</td>
												<td class="text-justify">
													<span>{{item?.makeAndModel}}</span>
												</td>
												<td class="text-justify">
													<span>{{item?.importedIndgenous}}</span>
												</td>
												<td class="text-justify">
													<span>{{item?.estimatedCost}}</span>
												</td>
												<td class="text-justify">
													<span>{{item?.justification}}</span>
												</td>
												<td scope="col" class="text-wrap"
													*ngIf="(item?.transportInsuranceInstallationChargesFile != '')">
													<a href="{{item?.transportInsuranceInstallationChargesFile}}"
														target="_blank"><i
															class="feather avatar-icon font-medium-1 icon-arrow-down-circle"
															title="Download Document"></i></a>
												</td>
											</tr>
											<tr *ngIf="form3coeArray.length == 0">
												<td colspan="6">No details are available.</td>
											</tr>
										</tbody>
									</table>
								</div>
								<span>*Including transport, insurance and installation charges.</span>
							</fieldset>
						</div>
					</div> -->

					<!-- <div class="row">
						<div class="form-group col-12">
							<fieldset class="border" style="padding: 0.7rem;">
								<legend class="w-auto">
									<h5 style="margin-top: 7px;">Manpower Cost</h5>
								</legend>
								<div class="table-responsive table-bordered">
									<table class="table table-striped table-bordered">
										<thead>
											<tr>
												<th scope="col" class="text-wrap" rowspan="2">Sr. No.</th>
												<th scope="col" class="text-wrap" rowspan="2">Designation/ Numbers</th>
												<th scope="col" class="text-wrap" rowspan="2">Justification</th>
												<th scope="col" class="text-wrap" rowspan="2">Monthly Salary</th>
												<th scope="col" class="text-wrap" style="text-align: center;"
												[attr.colspan]="dynamicColumnCount">Amount (Rs.)
												</th>
											<th scope="col" class="text-wrap" rowspan="2"></th> 
											</tr>
											<tr>
												<th scope="col" class="text-wrap"  *ngFor="let y of noOfYeararray">
													{{y.key}}
												</th>
												<th scope="col" class="text-wrap">Total</th>
											</tr>
										</thead>
										<tbody>
											<tr *ngFor="let item of manpowerDetailArray; let $index=index">

												<td scope="col" class="text-wrap">{{$index + 1}}.</td>
												<td style="min-width: 120px;" class="text-justify">
													{{item?.designation}}
												</td>
												<td style="min-width: 120px;" class="text-justify">
													{{item?.justification}}
												</td>
												<td style="min-width: 120px;" class="text-justify">
													{{item?.monthlyEmoluments}}
												</td>
												<td scope="col" class="text-wrap" *ngFor="let y of item?.years; let $index1 = index1">
													<span>{{y.value}}</span>
												</td>
												<td style="min-width: 120px;" class="text-justify">
													{{item?.total}}
												</td>
											</tr>
											<tr *ngIf="manpowerDetailArray?.length == 0">
												<td [attr.colspan]="dynamicColumnCount">No details are available.</td>
											</tr>
										</tbody>
									</table>
								</div>
								<span>*Man months to be given within brackets before the budget amount.</span>
							</fieldset>
						</div>
					</div> -->

					<!-- <div class="row">
						<div class="form-group col-12">
							<fieldset class="border" style="padding: 0.7rem;">
								<legend class="w-auto">
									<h5 style="margin-top: 7px;">Cost of Consumables</h5>
								</legend>
								<div class="table-responsive table-bordered">
									<table class="table table-striped table-bordered">
										<thead>
											<tr>
												<th scope="col" class="text-wrap" rowspan="2">Sr. No.</th>
												<th scope="col" class="text-wrap" rowspan="2">Item</th>
												<th scope="col" class="text-wrap" rowspan="2">Quantity</th>
												<th scope="col" class="text-wrap" rowspan="2">Unit</th>
												<th scope="col" class="text-wrap" style="text-align: center;"
												[attr.colspan]="noOfYeararray.length">
													Amount (Rs.)
												</th>
											</tr>
											<tr>
												<th scope="col" class="text-wrap"  *ngFor="let y of noOfYeararray">
													{{y.key}}
												</th>
											</tr>
										</thead>
										<tbody>
											<tr *ngFor="let item of costOfConsumableArray; let $index=index">
												<td scope="col" class="text-justify">{{$index + 1}}.</td>
												<td scope="col" class="text-justify">{{item?.item}}</td>
												<td scope="col" class="text-justify">{{item?.qty}}</td>
												<td scope="col" class="text-justify">{{item?.unitName}}</td>
												<td scope="col" class="text-justify" *ngFor="let y of item?.years; let $index1 = index1">
													<span>{{y.value}}</span>
												</td>
											</tr>
											<tr *ngIf="costOfConsumableArray?.length > 0">
												<td
													scope="col"
													colspan="4"
													class="text-wrap"
													style="text-align: right"
												>
													Total:
												</td>
												<td scope="col" class="text-wrap" *ngFor="let y of noOfYeararray">
													<span>{{y.costofConsumableTotal}}</span>
												</td>
											</tr>
											<tr *ngIf="costOfConsumableArray?.length == 0">
												<td [attr.colspan]="dynamicColumnCount">No details are available.</td>
											</tr>
										</tbody>
										
									</table>
								</div>
							</fieldset>
						</div>
					</div> -->
					<!-- <div class="row">
						<div class="form-group col-12">
							<fieldset class="border" style="padding: 0.7rem;">
								<legend class="w-auto">
									<h5 style="margin-top: 7px;">Travel Cost</h5>
								</legend>
								<div class="table-responsive table-bordered">
									<table class="table table-striped table-bordered">
										<thead>
											<tr>
												<th scope="col" class="text-wrap" rowspan="2">Sr. No.</th>
												<th scope="col" class="text-wrap" rowspan="2">Travel (Domestic/International)</th>
												<th scope="col" class="text-wrap" rowspan="2">Justification</th>
												<th scope="col" class="text-wrap" style="text-align: center;" [attr.colspan]="dynamicColumnCount">
													Amount (Rs.)
												</th>
											</tr>
											<tr>
												<th scope="col" class="text-wrap"  *ngFor="let y of noOfYeararray">
													{{y.key}} (m. m.*)
												</th>
												<th scope="col" class="text-wrap">Total</th>
											</tr>
										</thead>
										<tbody>
											<tr *ngFor="let item of travelCostArray; let $index=index">
												<td scope="col" class="text-wrap">{{$index + 1}}.</td>
												<td style="min-width: 120px;" class="text-justify">
													{{item?.title}}
												</td>
												<td style="min-width: 120px;" class="text-justify">
													{{item?.justification}}
												</td>
												<td scope="col" class="text-wrap" *ngFor="let y of item?.years; let $index1 = index1">
													<span>{{y.value}}</span>
												</td>
												<td style="min-width: 120px;" class="text-justify">
													{{item?.total}}
												</td>
											</tr>
											<tr *ngIf="travelCostArray?.length == 0">
												<td [attr.colspan]="dynamicColumnCount">No details are available.</td>
											</tr>
										</tbody>
									</table>
								</div>
							</fieldset>
						</div>
					</div> -->

					<div class="row">
						<!-- <div class="form-group col-4">
							<fieldset class="border" style="padding: 0.7rem;">
								<legend class="w-auto">
									<h5 style="margin-top: 7px;">Expert Comments</h5>
								</legend>
								<table class="table table-striped table-bordered">
									<thead>
										<tr>
											<th>
												Expert Name
											</th>
											<th>
												Rating
											</th>
											<th *ngIf="!this.isUser">
												Download
											</th>
										</tr>
									</thead>
									<tbody>
										<tr *ngFor="let exp of expertList">
											<td class="text-justify"> <a href="Javascript:void(0)"
													(click)="viewComment(modalExpertEvalution, exp?.id)"><span>{{exp?.name}}</span></a></td>
											<td class="text-justify"> {{exp?.totalRating}}/100</td>
											<td class="text-justify"   *ngIf="exp.expertCommentsUrl && !this.isUser" > 
												<a href="{{exp?.expertCommentsUrl}}" target="_blank">
													<i class="feather avatar-icon font-medium-1 icon-arrow-down-circle"
														title="Download"></i>
												</a>
											</td>
										</tr>
										<tr *ngIf="expertList.length == 0">
											<td colspan="2">No details are available.</td>
										</tr>
									</tbody>
								</table>
							</fieldset>
						</div> -->
						<!-- <div class="form-group" [ngClass]="!this.isUser ? 'col-8' : 'col-12'">
							<fieldset class="border" style="padding: 0.7rem;">
								<legend class="w-auto">
									<h5 style="margin-top: 7px;">Review Report</h5>
								</legend>
								<div class=" table-responsive">
								<table class="table table-striped table-bordered">
									<thead>
										<tr>
											<th> Stage </th>
											<th> Submission Date </th>
											<th> Status </th>
											<th> Action Date </th>
											<th> Download </th>
										</tr>
									</thead>
									<tbody>
										<tr *ngFor="let item of reviewList">
											<td>
												<a href="Javascript:void(0)"
													(click)="progressReportDetails(modalPR,item.progressReportId)"><span>{{item?.reviewReportCount}}</span></a>
											</td>
											<td class="text-justify"> {{item?.submitionDate}}</td>
											<td class="text-justify"> {{item?.progressReportStatus}}</td>
											<td class="text-justify"> {{item?.statusDate}}</td>
											<td class="text-justify"> <a href="{{item?.reviewReportUrl}}" target="_blank">
													<i class="feather avatar-icon font-medium-1 icon-arrow-down-circle"
														title="Download"></i>
												</a></td>
										</tr>
										<tr *ngIf="reviewList.length == 0">
											<td colspan="5">No details are available.</td>
										</tr>
									</tbody>
								</table>
							</div>
							</fieldset>
						</div> -->
						
					</div>
				<!-- </div> -->
			<!-- </div> -->
		</section>
	</div>
	
</div>